import * as Dialog from '@radix-ui/react-dialog';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { activity } from '../api/client';
import { ME_KEY, useLogout } from '../auth/session';

/** docs/06 §4: 30 min sin uso; el aviso sale 2 min antes (RF-AUTH-07). */
export const IDLE_MS = 30 * 60_000;
export const WARN_BEFORE_MS = 2 * 60_000;

export function SessionWarning({ now = () => Date.now() }: { now?: () => number }) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const logout = useLogout();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const tick = () => {
      const idle = now() - activity.last;
      if (idle >= IDLE_MS) void queryClient.invalidateQueries({ queryKey: ME_KEY });
      setOpen(idle >= IDLE_MS - WARN_BEFORE_MS && idle < IDLE_MS);
    };
    const timer = setInterval(tick, 10_000);
    return () => {
      clearInterval(timer);
    };
  }, [now, queryClient]);

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Portal>
        <Dialog.Overlay className="overlay" />
        <Dialog.Content className="modal">
          <Dialog.Title asChild>
            <h2>{t('auth.sessionExpiring')}</h2>
          </Dialog.Title>
          <Dialog.Description className="muted">{t('auth.sessionExpiringHelp')}</Dialog.Description>
          <div className="row" style={{ justifyContent: 'flex-end' }}>
            <button
              type="button"
              className="btn"
              onClick={() => {
                logout.mutate();
              }}
            >
              {t('topbar.signOut')}
            </button>
            <button
              type="button"
              className="btn pri"
              onClick={() => {
                // Cualquier pedido renueva la inactividad en el servidor.
                void queryClient.refetchQueries({ queryKey: ME_KEY });
                setOpen(false);
              }}
            >
              {t('auth.stayConnected')}
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
